import "./style.scss";

import React, { useContext, useEffect, useRef, useState } from "react";

import { AppStateContext } from "../../state/provider";
import { CfmWidget } from "../CfmWidget";
import { getTranslationFeedbackWidgetConfig } from "../CfmWidget/config";
import { useMounted } from "../hooks/common";
import { Translation } from "../Translation";

export const TranslationSurvey: React.FC<unknown> = () => {
  const refCurrentViewedContactId = useRef<string>(); // This is use to keep track of the current contact on the screen.
  const mounted = useMounted();
  const appState = useContext(AppStateContext);
  const [displaySurvey, setDisplaySurvey] = useState<boolean>(false);

  /**
   * This function returns true if translation is used in the specified contact
   * @param contact the Amazon Connect contact object
   * @returns
   */
  const isEndedTranslatedContact = (contact: connect.Contact): boolean => {
    return (
      contact.getState().type === connect.ContactStateType.ENDED &&
      contact.getType() === connect.ContactType.CHAT &&
      Translation.instance.isContactTranslated(contact.contactId)
    );
  };

  /**
   * This function returns the contact object of the specified contact id corresponding to an agent
   * @param agent the agent object.
   * @param contactId the contactId in Amazon Connect.
   * @returns
   */
  const findChatContact = (
    agent: connect.Agent,
    contactId: string
  ): connect.Contact | undefined => {
    const contact = agent
      .getContacts(connect.ContactType.CHAT)
      .find((contact) => contact.contactId === contactId);
    return contact;
  };

  useEffect(() => {
    if (appState.ccpInitialized) {
      connect.agent((agent) => addConnectEventListeners(agent));
    }
  }, [appState.ccpInitialized]);

  // add connect event listeners
  const addConnectEventListeners = (agent: connect.Agent): void => {
    // get contact id of current contact in view
    // subscribe to changes in the viewed contact and
    // display the survey if the contact in view is an ended contact with translation
    connect.core.onViewContact((viewedContact) => {
      if (mounted.current) {
        refCurrentViewedContactId.current = viewedContact.contactId;
        const contact = findChatContact(agent, viewedContact.contactId);
        if (contact) {
          setDisplaySurvey(isEndedTranslatedContact(contact));
        } else {
          setDisplaySurvey(false);
        }
      }
    });
    connect.contact((contact) => {
      // display the survey if the contact in view is an ended contact with translation
      contact.onEnded((contact) => {
        if (mounted.current) {
          if (refCurrentViewedContactId.current === contact.contactId) {
            setDisplaySurvey(isEndedTranslatedContact(contact));
          }
        }
      });

      contact.onDestroy((contact) => {
        if (mounted.current) {
          if (refCurrentViewedContactId.current === contact.contactId) {
            setDisplaySurvey(false);
          }
        }
      });
    });
  };
  return displaySurvey ? (
    <div className="translation-survey-container">
      <CfmWidget
        contactID={refCurrentViewedContactId.current}
        configFunc={getTranslationFeedbackWidgetConfig}
      ></CfmWidget>
    </div>
  ) : (
    <></>
  );
};
